import React from "react";
import ContractAndPaymentTerms from "./ContractAndPaymentTermsOverview";
import ProjectDetailsOverview from "./ProjectDetailsoverview";
import CompanyInformation from "./CompanyInformationOverview";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";

const ProjectInformationOverview = ({ data }) => {
  if (!data) return <DataNotFound />;
  return (
    <React.Fragment>
      <ProjectDetailsOverview data={data} />
      <div className="mb-16"></div>
      <ContractAndPaymentTerms data={data} />
      <div className="mb-16"></div>
      <CompanyInformation data={data} />
    </React.Fragment>
  );
};
export default ProjectInformationOverview;
